// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const apiServer="https://devservice.popinhotel.com/service/"

export const environment = {
  production: false,
  apiLogin: apiServer+"login",
  apiGetbooksfromhotel: apiServer+"getbooksfromhotel",
  apiGethotel: apiServer+"gethotel",
  apiUpdatehotel:  apiServer+"updatehotel",
  apiGetuser: apiServer+"getuser",
  apiUpdateuser:  apiServer+"updateuser",  
  apiCreateuser:  apiServer+"createuser",
  apiGetTransactions: apiServer+"gettransactions",
  apiGetTransactioncsv: apiServer+"gettransactioncsv",
  apiUpdatetransaction:  apiServer+"updatetransaction",
  apiUpdatebooking:  apiServer+"updatebooking",
  apiGetcard:  apiServer+"getcard"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
